import { apiUrl } from "../../../Constant/apiConstant"
import { postJsonRequest } from "../../../service/apiService"

export const editUserByUser= async (tenant: string | undefined,payLoad:any)=>{
    try{
        const response = await postJsonRequest(apiUrl.UM_POST_EDIT_USER_BY_USER,payLoad,tenant,true)

        if(response.status === 200){
            const {Status} =response.data

            return Status
        }
    }catch(error){
        console.log(error)
    }

    return false
}

export const changePasswordByAuth = async (tenant:string | undefined,payLoad:any)=>{
    try{
        const response = await postJsonRequest(apiUrl.UM_POST_CHANGE_PASSWORD_BY_AUTH,payLoad,tenant,true)

        if(response.status === 200){
            const {Status}=response.data

            return Status
        }
    }catch(error){
        console.log(error)
    }
    return false
}